import { useEffect, useState } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import { Col, Row } from 'react-bootstrap'
import axios from 'axios'
import { useTranslation } from 'react-multi-lang'
import { Fade, Zoom } from 'react-awesome-reveal'
import '../../styles/Home/HomeActuality.css'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'

function HomeActuality() {

    const navigate = useNavigate()

    const text = useTranslation()
    const [actualities, setActualities] = useState([])

    useEffect(() => {

        getActuality()

    }, [])

    function getActuality() {

        axios.get(process.env.REACT_APP_API_URL + 'actuality').then((response) => {
            if (response.data) {
                const items = response.data.slice(0, 3).map((item) => {
                    item.date = new Date(item.date).toLocaleDateString("fr-FR")
                    item.createdAt = new Date(item.createdAt).toLocaleDateString("fr-FR", { hour: 'numeric', minute: 'numeric' })
                    item.updatedAt = new Date(item.updatedAt).toLocaleDateString("fr-FR", { hour: 'numeric', minute: 'numeric' })
                    item.image = process.env.REACT_APP_API_URL + 'actuality/' + item.id + '/image'
                    return item
                })
                setActualities(items)
            }
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
        })

    }

    return (

        <>
            <BrowserView>
                {actualities.length > 0 ?
                    <div className='homeActuality'>
                        <div className='homeSectionTitle'>Dernières actualités</div>
                        <div className='homeActualityRow'>
                            <Row>
                                {actualities.map((item) => {
                                    return (
                                        <Col key={item.id} sm={4}>
                                            <Zoom duration={500}>
                                                <div className='actualityItem' onClick={() => navigate('/actualités/' + item.id, { state: { actuality: item } })}>
                                                    <div className='actualityItemImage'>
                                                        <img src={item.image} width={'100%'} alt="actualityImage" loading="lazy" />
                                                    </div>
                                                    <div className='actualityItemDate'>
                                                        <FontAwesomeIcon icon={faClock} className='actualityItemDateIcon' />
                                                        {item.date}
                                                    </div>
                                                    <div className='actualityItemTitle'>{item.title}</div>
                                                </div>
                                            </Zoom>
                                        </Col>
                                    )
                                })}
                            </Row>
                        </div>
                    </div>
                    : null
                }
            </BrowserView>

            <MobileView>
                <div id='actuality'>
                    <Fade>
                        <div className='actualityTitle'>{text('actuality.title')}</div>
                    </Fade>
                    <Row>
                        {actualities.map((item) => {
                            return (
                                <Col key={item.id} sm={4}>
                                    <Zoom duration={500}>
                                        <div className='actualityItemMobile' onClick={() => navigate('/actualités/' + item.id, { state: { actuality: item } })}>
                                            <div className='actualityItemImage'>
                                                <img src={item.image} width={'100%'} alt="actualityImage" loading="lazy" />
                                            </div>
                                            <div className='actualityItemDate'>
                                                <FontAwesomeIcon icon={faClock} className='actualityItemDateIcon' />
                                                {item.date}
                                            </div>
                                            <div className='actualityItemTitle'>{item.title}</div>
                                        </div>
                                    </Zoom>
                                </Col>
                            )
                        })}
                    </Row>
                </div>
            </MobileView>
        </>

    )

}

export default HomeActuality
